export const options = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'French' },
];
